var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoTaxInvoiceGeneration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m391 0h-225c-24.853 0-45 20.147-45 45v422c0 24.853 20.147 45 45 45h300c24.853 0 45-20.147 45-45v-347z",
    fill: "#e4f2f9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m391 0h-75v512h150c24.853 0 45-20.147 45-45v-347z",
    fill: "#bde0f1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m391 0v105c0 8.284 6.716 15 15 15h105z",
    fill: "#77bee2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5f5f82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m426 302h-220c-8.284 0-15-6.716-15-15s6.716-15 15-15h220c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426 212h-220c-8.284 0-15-6.716-15-15s6.716-15 15-15h220c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426 392h-220c-8.284 0-15-6.716-15-15s6.716-15 15-15h220c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m441 287c0-8.284-6.716-15-15-15h-110v30h110c8.284 0 15-6.716 15-15z",
    fill: "#3c3c55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m441 197c0-8.284-6.716-15-15-15h-110v30h110c8.284 0 15-6.716 15-15z",
    fill: "#3c3c55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m426 392c8.284 0 15-6.716 15-15s-6.716-15-15-15h-110v30z",
    fill: "#3c3c55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m136 512c-74.439 0-135-60.561-135-135s60.561-135 135-135 135 60.561 135 135-60.561 135-135 135z",
    fill: "#fad723"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m136 242v270c74.439 0 135-60.561 135-135s-60.561-135-135-135z",
    fill: "#f5b400"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m136 272c-57.897 0-105 47.103-105 105s47.103 105 105 105 105-47.103 105-105-47.103-105-105-105z",
    fill: "#f5f57f"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m136 272v210c57.897 0 105-47.103 105-105s-47.103-105-105-105z",
    fill: "#fad723"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m144.333 362h-16.667c-.919 0-1.667-.748-1.667-1.667v-16.666c0-.919.748-1.667 1.667-1.667h16.667c.919 0 1.667.748 1.667 1.667 0 8.284 6.716 15 15 15s15-6.716 15-15c0-15.174-10.73-27.884-25-30.955v-5.712c0-8.284-6.716-15-15-15s-15 6.716-15 15v5.712c-14.27 3.071-25 15.781-25 30.955v16.666c0 17.461 14.206 31.667 31.667 31.667h16.667c.919 0 1.667.748 1.667 1.667v16.666c0 .919-.748 1.667-1.667 1.667h-16.667c-.919 0-1.667-.748-1.667-1.667 0-8.284-6.716-15-15-15s-15 6.716-15 15c0 15.174 10.73 27.884 25 30.955v5.712c0 8.284 6.716 15 15 15s15-6.716 15-15v-5.712c14.27-3.071 25-15.781 25-30.955v-16.666c0-17.461-14.206-31.667-31.667-31.667z",
    fill: "#fad723"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m144.333 342c.919 0 1.667.748 1.667 1.667 0 8.284 6.716 15 15 15s15-6.716 15-15c0-15.174-10.73-27.884-25-30.955v-5.712c0-8.284-6.716-15-15-15v50z",
    fill: "#f5b400"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m144.333 362h-8.333v30h8.333c.919 0 1.667.748 1.667 1.667v16.666c0 .919-.748 1.667-1.667 1.667h-8.333v50c8.284 0 15-6.716 15-15v-5.712c14.27-3.071 25-15.781 25-30.955v-16.666c0-17.461-14.206-31.667-31.667-31.667z",
    fill: "#f5b400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoTaxInvoiceGeneration);
export default __webpack_public_path__ + "static/media/auto-tax-invoice-generation.7f30f4596bdb0e104b339f6cf5cfe173.svg";
export { ForwardRef as ReactComponent };